// @flow

import React, { type Element } from 'react';
import {
  ModalContainer as StyledModalContainer,
  ModalFlexWrapper,
  overlayStyle,
} from './modalContainer.styled';
import type { TextAlign } from '../../../types';

type Props = {
  align: TextAlign,
  ariaLabel: ?string,
  children: Array<Element<*>>,
  closeOnOverlayClick: boolean,
  isOpen: boolean,
  onClose: Function,
  size: 'small' | 'medium' | 'large';
};

export default ({
  align = 'left',
  children,
  size,
  isOpen,
  onClose,
  closeOnOverlayClick,
  ariaLabel,
}: Props) => (
  <StyledModalContainer
    align={align}
    contentLabel={ariaLabel}
    isOpen={isOpen}
    onRequestClose={onClose}
    shouldCloseOnOverlayClick={closeOnOverlayClick}
    size={size}
    style={overlayStyle}
  >
    <ModalFlexWrapper>{children}</ModalFlexWrapper>
  </StyledModalContainer>
);
